import gql from 'graphql-tag';

export interface Jobtype {
  id: number;
  code: string;
  description: string;
  detailedDescription: string;
  chargingCode: string;
  materialId: number;
  isActive: boolean;
  firstDate: string;
}

export interface JobtypesOutput {
  data: Jobtype[];
  recordCount: number;
}

export interface GetJobtypesQueryVariables {
  limit?: number;
  offset?: number;
  order?: string;
  where?: string;
}

export const gqlGetEdocs = gql`
  query getEdocs($limit: Int, $offset: Int, $order: String, $where: String) {
    getEdocs(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        edocseriesId
        edocPrefix
        edocNumber
        edocDate
        edocTypeId
        referenceId
        jsonContent
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
        edocSeries {
          id
          name
          edocSeriesType {
            value
            name
          }
        }
      }
      recordCount
    }
  }
`;

export const gqlDeleteEdoc = gql`
  mutation deleteEdoc($id: Int) {
    deleteEdoc(id: $id)
  }
`;

export const gqlAddJobtype = gql`
  mutation addJobtype($data: JobtypeInput) {
    addJobtype(data: $data) {
      id
    }
  }
`;

export const gqlUpdateJobtype = gql`
  mutation updateJobtype($data: JobtypeInput) {
    updateJobtype(data: $data) {
      id
    }
  }
`;

export const gqlDeleteJobtype = gql`
  mutation deleteJobtype($id: Int) {
    deleteJobtype(id: $id)
  }
`;

export const gqlGetJobtypeById = gql`
  query getJobtypeById($id: Int) {
    getJobtypeById(id: $id) {
      id
      code
      description
      detailedDescription
      chargingCode
      materialId
      isActive
      firstDate
      material {
        name
      }
    }
  }
`;

export const gqlGetMaterials = gql`
  query getMaterials($where: String, $limit: Int) {
    getMaterials(where: $where, limit: $limit) {
      data {
        id
        name
      }
      recordCount
    }
  }
`;
